import { P } from "@/shared/ui/typographies/paragraph";

export const CardWelcomeSlideContent = () => (
  <P className="text-base text-muted text-center space-y-4 animate-slide-up-delayed text-pretty">
    Cliquez sur "Commencer l'activation" pour saisir votre code d'activation.
  </P>
);
